import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { DischargeSummaryQuestionnaireItem } from './questionnaire'

export const DISCHARGE_SUMMARY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [DischargeSummaryQuestionnaireItem.DISCHARGE_SUMMARY]: QuestionnaireAnswerType.GROUP,
  [DischargeSummaryQuestionnaireItem.DISCHARGE_SUMMARY_TYPES_OF_SERVICES]:
    QuestionnaireAnswerType.STRING,
  [DischargeSummaryQuestionnaireItem.DISCHARGE_SUMMARY_SERVICE_FREQUENCY]:
    QuestionnaireAnswerType.STRING,
  [DischargeSummaryQuestionnaireItem.DISCHARGE_SUMMARY_LAST_DATE_OF_SERVICE]:
    QuestionnaireAnswerType.DATE,
  [DischargeSummaryQuestionnaireItem.DISCHARGE_SUMMARY_DISCHARGE_CONDITION]:
    QuestionnaireAnswerType.STRING,
  [DischargeSummaryQuestionnaireItem.DISCHARGE_SUMMARY_REASON_FOR_DISCHARGE]:
    QuestionnaireAnswerType.STRING,
  [DischargeSummaryQuestionnaireItem.DISCHARGE_SUMMARY_LABORATORY_DATA]:
    QuestionnaireAnswerType.STRING,
  [DischargeSummaryQuestionnaireItem.DISCHARGE_SUMMARY_PLAN_OF_CARE_OUTCOMES]:
    QuestionnaireAnswerType.STRING,
  [DischargeSummaryQuestionnaireItem.DISCHARGE_SUMMARY_DISCHARGE_INSTRUCTIONS]:
    QuestionnaireAnswerType.STRING,
  [DischargeSummaryQuestionnaireItem.DISCHARGE_SUMMARY_POST_DISCHARGE_TREATMENT]:
    QuestionnaireAnswerType.STRING,
  [DischargeSummaryQuestionnaireItem.DISCHARGE_SUMMARY_POST_DISCHARGE_GOALS]:
    QuestionnaireAnswerType.STRING
}
